import { createVNode as _createVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "duration-selector" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["CalendarInput"], {
      fromDate: $setup.searchFromDate,
      toDate: $setup.searchToDate,
      dateFormat: 'YYYY.MM.DD',
      onOnClickFromDate: _cache[0] || (_cache[0] = ($event: any) => ($setup.toggleShowFromDateCalendar(true))),
      onOnClickToDate: _cache[1] || (_cache[1] = ($event: any) => ($setup.toggleShowToDateCalendar(true)))
    }, null, 8 /* PROPS */, ["fromDate", "toDate"]),
    _createCommentVNode(" [시작 날짜] 달력 "),
    ($setup.shouldShowFromDateCalendar)
      ? (_openBlock(), _createBlock($setup["Calendar"], {
          key: 0,
          initialSelectedDate: $setup.searchFromDate,
          selectableFromDate: $props.minSelectableDate,
          selectableToDate: $props.maxSelectableDate,
          onOnSelectDate: $setup.handleSelectFromDate,
          onOnClickClose: _cache[2] || (_cache[2] = ($event: any) => ($setup.toggleShowFromDateCalendar(false)))
        }, null, 8 /* PROPS */, ["initialSelectedDate", "selectableFromDate", "selectableToDate"]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" [만료 날짜] 달력 "),
    ($setup.shouldShowToDateCalendar)
      ? (_openBlock(), _createBlock($setup["Calendar"], {
          key: 1,
          initialSelectedDate: $setup.searchToDate,
          selectableFromDate: $props.minSelectableDate,
          selectableToDate: $props.maxSelectableDate,
          onOnSelectDate: $setup.handleSelectToDate,
          onOnClickClose: _cache[3] || (_cache[3] = ($event: any) => ($setup.toggleShowToDateCalendar(false)))
        }, null, 8 /* PROPS */, ["initialSelectedDate", "selectableFromDate", "selectableToDate"]))
      : _createCommentVNode("v-if", true)
  ]))
}